var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav_bar" },
    [
      _vm.showLoggedInContent && _vm.isEngineer && _vm.navItems.length
        ? [
            _vm.isMobile
              ? _c("HKLSelect", {
                  attrs: {
                    options: _vm.navItems,
                    placeholder: _vm.placeholder,
                    align: "right",
                  },
                  on: { select: _vm.activatePage },
                  model: {
                    value: _vm.displayItem,
                    callback: function ($$v) {
                      _vm.displayItem = $$v
                    },
                    expression: "displayItem",
                  },
                })
              : _c(
                  "ul",
                  [
                    _vm._l(_vm.navItems, function (item, index) {
                      return [
                        _c(
                          "li",
                          {
                            key: index,
                            attrs: { active: item.isActive },
                            on: {
                              click: function () {
                                return _vm.activatePage(item.value)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " + _vm._s(item.label) + "\n        "
                            ),
                          ]
                        ),
                      ]
                    }),
                  ],
                  2
                ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }